import { CHANGE_GENERAL_STORE_SETTINGS, CLOSE_ARAG_USER_SETTINGS_MENU, OPEN_ARAG_USER_SETTINGS_MENU } from "../actions";

const defaultState = {
    isSettingsMenuOpen: false,
};

export default (state = defaultState, action) => {
    switch (action.type){
        case OPEN_ARAG_USER_SETTINGS_MENU:
            return {
                ...state,
                isSettingsMenuOpen: true
            };
        case CLOSE_ARAG_USER_SETTINGS_MENU:
            return {
                ...state,
                isSettingsMenuOpen: false
            };
        case CHANGE_GENERAL_STORE_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                isSettingsMenuOpen: defaultState.isSettingsMenuOpen
            };
        default:
            return state
    }
}